import * as React from "react";

export const FilledHouseIcon = (props: any) => (
  <svg
    width={14}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.667 2.735 1.608 7.197c-.037.034-.085.05-.127.078v4.28c0 .205.166.37.37.37h3.455l.027-3.592h3v3.593h3.148a.37.37 0 0 0 .37-.37v-4.28c-.039-.027-.085-.043-.121-.075L6.667 2.735Zm6.543 2.809-1.358-1.2V1.185a.37.37 0 0 0-.37-.37H10a.37.37 0 0 0-.37.37v1.197L7.286.312a.925.925 0 0 0-1.237 0L.123 5.544a.37.37 0 0 0-.028.523l.495.551a.37.37 0 0 0 .523.028l5.309-4.682a.37.37 0 0 1 .49 0l5.308 4.682a.37.37 0 0 0 .523-.028l.496-.552a.37.37 0 0 0-.029-.522Z"
      fill="#757575"
    />
  </svg>
);
